import Vue from "vue";
import VueRouter from "vue-router";
import SignIn from "../views/auth/SignIn";
import PageNotFound from "../views/error/PageNotFound";
import TrackerForm from "../views/tracker/TrackerForm";
import TrackerDetails from "../views/tracker/TrackerDetails";
import PickaserviceInvoiceForm from "../views/invoices/PickaserviceInvoiceForm";
import PriceCalculator from "../views/calculator/PriceCalculator";

Vue.use(VueRouter);

const DEFAULT_TITLE = "Pickaservice"

const routes = [
  {
    path: "/auth/sign-in",
    name: "sign-in",
    component: SignIn,
    beforeEnter: (to, from, next) => {
      if (localStorage.getItem("authToken")) {
        next("test-create-invoice");
      } else {
        next();
      }
    },
  },
  {
    path: "/",
    name: "tracker-form",
		meta: {
			title: "Track your packages",
		},
    component: TrackerForm,
  },
  {
    path: "/calculator/",
    name: "calculator",
		meta: {
			title: "Shipping Calculator",
		},
    component: PriceCalculator,
  },
  {
    path: "/:accessCode/",
    name: "tracker-details",
		meta: {
			title: "Track your packages",
		},
    component: TrackerDetails,
  },
  {
    path: "/test-invoice/create/",
    name: "test-create-invoice",
    component: PickaserviceInvoiceForm,
  },
  {
    path: "*",
    name: "404",
    component: PageNotFound,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (!localStorage.getItem("authToken") &&
      (to.name === "test-create-invoice")) {
    next({ name: "sign-in" });
  } else {
    next();
  }
});

router.afterEach((to, from) => {
    Vue.nextTick(() => {
        document.title = to.meta.title || DEFAULT_TITLE;
    });
});

export default router;
